import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import {
  OreButton,
  OreDivider,
  OreHeading,
  OreStack,
} from '@edenredespana/oreneta'
import { storesTranslation } from '@/Store/ui/storesTranslation'

type ExcelLayoutProps = PropsWithChildren & {
  onCancel?: () => void
  onContinue?: () => void
  OnContinueText?: string
  continueDisabled?: boolean
}

export const ExcelLayout = ({
  onCancel,
  onContinue,
  continueDisabled,
  OnContinueText,
  children,
}: ExcelLayoutProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <OreStack direction="column" space="small" placeContent="stretch" style={{ marginTop: '1rem', padding: '2rem' }}>
      <OreStack space="medium" placeContent="stretch">
        <OreStack space="2xsmall" placeContent="stretch">
          <OreHeading as="h1" size="title-sm">
            {t(storesTranslation.excelTpvUpload.pageTitle)}
          </OreHeading>
          <OreDivider space="medium" />
        </OreStack>
        {children}
      </OreStack>
      {onCancel || onContinue ? (
        <>
          <OreDivider space="medium" />
          <OreStack space="small" placeContent="stretch">
            <OreStack space="medium" direction="row" placeContent="end">

              {onCancel ? (

                <OreButton type="submit" category="secondary" onClick={onCancel}>
                  {t(storesTranslation.excelTpvUpload.cancel)}
                </OreButton>
              ) : null}

              {onContinue ? (

                <OreButton
                  type="submit"
                  category="primary"
                  disabled={continueDisabled}
                  onClick={onContinue}>
                  {OnContinueText ? t(OnContinueText) : t(storesTranslation.excelTpvUpload.send)}
                </OreButton>
              ) : null}
            </OreStack>
          </OreStack>
        </>
      ) : null}
    </OreStack>
  )
}
